import {
  Button,
  Checkbox,
  Col,
  Divider,
  Drawer,
  Form,
  Menu,
  Popover,
  Row,
  Typography,
} from "antd";
import DocUpdateIcon from "../../assets/DocUpdateIcon.svg";
import HipaaSeal from "../../assets/hipaaSeal.png";
import { ReactComponent as MenuFoldIcon } from "../../assets/MenuUnfoldIcon.svg";
import appBarCode from "../../assets/appBarCode.png";
import { ReactComponent as SignUpDocIcon } from "../../assets/signupdocIcon.svg";
import { useForm } from "../../utils/hooks/useForm";
import "react-phone-input-2/lib/style.css";
import FloatInput from "../../components/FloatInput/floatInput";
import "./signin.modules.css";
import { Link, useNavigate } from "react-router-dom";
import SignUpDocMiniIcon from "../../assets/signupMiniIcon.webp";
import { useAuth } from "../../utils/hooks/useAuth"; // Import the useAuth hook
import {
  emailPattenValidation,
  passwordPatternValidation,
} from "../../utils/methods/form-validations";
import { DownOutlined } from "@ant-design/icons";
import { useSideBarMenu } from "../../utils/content/sidebar-menus";
import HipaaSealImage from "../../components/HipaaSeal/HipaaSeal";

const SignInV1 = () => {
  const navigate = useNavigate();
  const { form } = useForm();
  const { NAVBAR_INFO_MOBILE, POPUP_CONTENT, open, setOpen } = useSideBarMenu();
  const { signin, isLoading } = useAuth(form); // Call the useAuth hook

  const onFinishFailed = (errorInfo: any) => {};

  const handleFinish = async (values: any) => {
    try {
      await signin(values); // Call onSubmit from the useAuth hook
    } catch (error) {
      onFinishFailed(error);
    }
  };

  return (
    <div className="bg-custom-radial flex flex-col w-full h-full justify-between">
      <div className="my-2 flex flex-col justify-center items-center px-6 py-4 w-full max-w-[1440px] mx-auto lg:gap-y-8">
        <div className="flex justify-center items-center w-full max-w-screen-2xl lg:gap-x-40">
          <div className="flex justify-between gap-x-8 items-center w-full lg:w-auto">
            <Link to={"https://www.docupdate.io/"}>
              <img
                src={DocUpdateIcon}
                alt="docupdate"
                className="w-full max-w-48 object-contain mix-blend-normal lg:mr-auto"
              />
            </Link>
            <MenuFoldIcon
              onClick={() => setOpen((prevState) => !prevState)}
              className="lg:hidden text-[#565656]"
            />
            <Popover
              placement="bottom"
              title={""}
              content={POPUP_CONTENT}
              className="nav_popover"
            >
              <Link
                to={"https://www.docupdate.io/manage-preferences"}
                className="hidden link-block lg:flex justify-center items-center"
              >
                What We Offer <DownOutlined className="chevron-down" />
              </Link>
            </Popover>
            <Link
              to={"https://www.docupdate.io/manage-preferences"}
              className="hidden link-block lg:flex justify-center items-center"
            >
              Manage Preferences
            </Link>
          </div>
          <div className="hidden lg:flex justify-center gap-x-4 items-center">
            <Link
              to={"/signup-new"}
              className="link-button-white flex justify-center items-center"
            >
              Sign Up
            </Link>
            <Link
              to={"https://docupdate.onelink.me/j4xR/desktop"}
              className="link-button flex justify-center items-center"
            >
              Get the App
            </Link>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row justify-center items-center w-full lg:gap-x-20 lg:pl-10">
          <div className="hidden lg:flex lg:flex-col lg:gap-y-7 lg:justify-center lg:items-center lg:mb-auto lg:ml-2 lg:mt-10">
            <div className="flex flex-col gap-y-2 justify-center max-w-[390px]">
              <Typography.Text className="font-playfair font-bold text-[48px] leading-tight">
                Welcome to DocUpdate!
              </Typography.Text>
              <Typography.Text className="mt-6 font-urbanist font-bold text-[20px] tracking-[1%] leading-none">
                Sign in to manage your preferences and update your personal
                information.
              </Typography.Text>
              <Typography.Text className="font-urbanist font-medium text-lg text-[#050505]">
                Don’t have an account?
                <span
                  className="text-[#7E5AE2] cursor-pointer font-bold"
                  onClick={() => navigate("/signup-new")}
                >
                  {" "}
                  Register Now
                </span>
              </Typography.Text>
              <div className="mt-2 w-full">
                <SignUpDocIcon className="object-cover w-[95%] h-full" />
              </div>
            </div>
          </div>
          <div className="lg:hidden flex flex-col gap-y-4 justify-center items-center mt-10">
            <Typography.Text className="font-playfair font-semibold text-[42px] leading-[120%] tracking-[-2%] text-center">
              Welcome to Docupdate
            </Typography.Text>
            <Typography.Text className="font-playfair font-semibold text-[15px] text-center">
              Sign in to manage your preferences and update your personal
              information.
            </Typography.Text>
            <Typography.Text className="font-urbanist font-medium text-base text-[#050505]">
              Don’t have an account?
              <span
                className="text-[#7E5AE2] cursor-pointer font-bold"
                onClick={() => navigate("/signup-new")}
              >
                {" "}
                Register Now
              </span>
            </Typography.Text>
          </div>
          <div className="my-6 pt-2 flex flex-col w-full max-w-[470px] justify-center items-start rounded-xl mobile-m:rounded-3xl mobile-m:px-2 lg:my-0 lg:mt-8 gap-y-6">
            <Form
              form={form}
              name="signup"
              onFinish={handleFinish}
              onFinishFailed={onFinishFailed}
              className="pt-2 flex flex-col bg-white w-full max-w-[470px] justify-center items-center rounded-xl mobile-m:rounded-3xl mobile-m:px-2"
            >
              <div className="flex flex-col justify-center items-center max-w-[380px]">
                <Typography.Text className="font-playfair text-center text-3xl text-[#0F0F1C] font-bold">
                  Sign In
                </Typography.Text>
                <Typography.Text className="m-4 mb-0 font-urbanist text-center leading-4 text-[12px] text-normal text-[#5d6769] mobile-m:text-sm">
                  Welcome to DocUpdate. Please login to your account.
                </Typography.Text>

                {/* Tab container with absolute positioning */}
                <Row
                  gutter={[12, 12]}
                  className="px-5 xs:px-0 lg:!gap-y-5"
                  wrap
                  align={"middle"}
                  justify={"center"}
                >
                  {/* First Tab Fields */}
                  <Col span={24} className="signin-col">
                    <Form.Item
                      name="email"
                      rules={[
                        {
                          required: true,
                          message: "*Email Address is Required",
                        },
                        emailPattenValidation(),
                      ]}
                      validateFirst
                    >
                      <FloatInput
                        name={"email"}
                        type="text"
                        placeholder={"Email Address *"}
                        label="Email Address"
                        required={true}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24} className="signin-col">
                    <Form.Item
                      name="password"
                      rules={[
                        { required: true, message: "*Password is Required" },
                        passwordPatternValidation(),
                      ]}
                      validateFirst
                    >
                      <FloatInput
                        name="password"
                        type="password"
                        placeholder={"Enter Password *"}
                        label="Password"
                        required={true}
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    span={24}
                    className="mt-3 xs:mt-0 flex justify-between items-center max-h-custom"
                  >
                    <Typography.Text
                      className="text-xs text-[#6c838a] cursor-pointer"
                      onClick={() => navigate("/forgot-password")}
                    >
                      Forget password?
                    </Typography.Text>
                    <Form.Item name="remember" valuePropName="checked">
                      <Checkbox className="mr-1 text-xs text-[#6c838a]">
                        Remember Me
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>

                <Row className="w-full">
                  <Col span={24} className="text-center mt-2 lg:hidden">
                    <Typography.Text className="font-urbanist font-semibold text-sm text-[#050505]">
                      Don’t have an account?
                      <span
                        className="text-[#7E5AE2] cursor-pointer font-bold"
                        onClick={() => navigate("/signup-new")}
                      >
                        {" "}
                        Register Now
                      </span>
                    </Typography.Text>
                  </Col>
                  <Col
                    span={24}
                    className="my-3 mb-6 px-4 flex justify-center items-center w-full md:px-2 lg:px-0 lg:mt-5"
                  >
                    <Button
                      htmlType="submit"
                      className="bg-[#7E5AE2] text-white border-none w-full font-semibold rounded-md text-sm"
                      loading={isLoading}
                      iconPosition="end"
                    >
                      Sign In
                    </Button>
                  </Col>
                </Row>
              </div>
            </Form>
            <div className="hidden lg:flex flex-col gap-y-4">
              <Typography.Text className="font-bold text-lg font-poppins text-left w-full">
                Scan the QR code to download the app!
              </Typography.Text>
              <img
                src={appBarCode}
                className="ml-1 p-3 bg-white rounded-lg w-full max-w-32 app-bar-code-shadow"
              />
            </div>
          </div>
          <Link
            to={"https://docupdate.onelink.me/j4xR/desktop"}
            className="my-3 link-button flex justify-center items-center lg:hidden w-full max-w-[300px]"
          >
            Get the App
          </Link>
          <div className="mt-2 flex flex-col w-full h-full max-h-[318px] max-w-[430px] lg:hidden">
            <img
              src={SignUpDocMiniIcon}
              className="object-contain h-full w-[100%]"
            />
          </div>
        </div>
      </div>
      <div className="mt-6 bg-[#f2fdff] flex flex-col w-full justify-center items-center">
        <div className="min-h-400px px-6 py-4 flex w-full max-w-[1236px] justify-between items-start">
          <div className="flex flex-col justify-center items-start gap-y-4 md:gap-y-6">
            <Link to={"https://www.docupdate.io/"}>
              <img
                src={DocUpdateIcon}
                alt="docupdate"
                className="w-full max-w-48 object-contain mix-blend-normal"
              />
            </Link>
            <div className="flex flex-col items-start gap-y-4 md:flex-row md:gap-x-8">
              <Link
                to={"https://www.docupdate.io/manage-preferences"}
                className="link-block-light flex justify-center items-center"
              >
                Manage Preferences
              </Link>
              <Link
                to={"https://www.docupdate.io/#faq"}
                className="link-block-light flex justify-center items-center"
              >
                Help
              </Link>
              <Link
                to={"https://www.docupdate.io/privacy-policy/"}
                className="link-block-light flex justify-center items-center"
              >
                Privacy Policy
              </Link>
            </div>
          </div>
          <HipaaSealImage />
        </div>
        <Divider className="w-full max-w-screen-2xl" />
        <div className="flex flex-col md:flex-row justify-between items-center w-full p-4 max-w-[1236px] gap-y-3">
          <div className="flex justify-center items-center">
            <Typography.Text className="footer-text-color">
              Copyright © 2025 DocUpdate | All Rights Reserved.
            </Typography.Text>
          </div>
          <div className="flex justify-center gap-x-8 items-center">
            <Link
              to={"https://www.docupdate.io/terms-of-service/"}
              className="link-block-lighter flex justify-center items-center"
            >
              Terms of Service
            </Link>
            <Link
              to={"https://www.docupdate.io/do-not-call-policy/"}
              className="link-block-lighter flex justify-center items-center"
            >
              DNC Policy
            </Link>
            <Link
              to={
                "https://www.docupdate.io/hipaa-business-associate-agreement/"
              }
              className="link-block-lighter flex justify-center items-center"
            >
              HIPAA Terms
            </Link>
            <Link
              to={"https://www.docupdate.io/ccpa-notice/"}
              className="link-block-lighter flex justify-center items-center"
            >
              CCPA Notice
            </Link>
          </div>
        </div>
      </div>
      <Drawer
        placement="right"
        closable={true}
        onClose={() => setOpen(false)}
        open={open}
        destroyOnClose
        className={`navbar_drawer flex justify-center p-[0.85rem_1.5rem] w-full`}
      >
        <div className="flex flex-col gap-y-10 w-full h-full">
          <Menu
            mode="inline"
            className="w-full h-full border-none flex flex-col gap-y-4 max-h-[360px]"
            items={NAVBAR_INFO_MOBILE}
            defaultSelectedKeys={["1"]}
          />
          <Link
            to={"/login-new"}
            className="link-button-white flex justify-center items-center"
          >
            Sign In
          </Link>
          <Link
            to={"https://docupdate.onelink.me/j4xR/desktop"}
            className="link-button flex justify-center items-center"
          >
            Get the App
          </Link>
        </div>
      </Drawer>
    </div>
  );
};

export default SignInV1;
